class StoresCarousel extends HTMLElement {

  constructor() {
    super();

    this.selectors = {
      swiper: "swiper-container",
      scroll: ".swiper-scrollbar",
      prevEl: ".custom-prev-button",
      nextEl: ".custom-next-button"
    }

    this.slider = this.querySelector(this.selectors.swiper);
    this.scrollbar = this.querySelector(this.selectors.scroll);
    this.buttonPrev = this.querySelector(this.selectors.prevEl);
    this.buttonNext = this.querySelector(this.selectors.nextEl);
    this.initSlider();
  }

  initSlider() {
    const swiperParams = {
      slidesPerView: 1.331,
      spaceBetween: 10,
      slidesOffsetBefore: 15,
      slidesOffsetAfter: 15,
      breakpoints: {
        540: {
          slidesPerView: 1.75,
          spaceBetween: 15,
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
        },
        750: {
          slidesPerView: 1.55,
          spaceBetween: 15,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 15,
        },
        1200: {
          slidesPerView: "auto",
          spaceBetween: 15,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
        }
      },
      navigation: {
        nextEl: this.buttonNext,
        prevEl: this.buttonPrev
      },
      scrollbar: {
        el: this.scrollbar,
        draggable: true,
      },
      on: {
        init() {
        }
      },
    };

    Object.assign(this.slider, swiperParams);

    this.slider.initialize();

  }
}

customElements.define('component-stores-carousel', StoresCarousel);